module.exports = __webpack_public_path__ + "media/images/regions/carte+du+niger-c65795c004837d5b0902aeda8674cd51.png";